import {defineMessages} from 'react-intl';

export const closeConfirmationMessages = defineMessages({
  title: {
    id: 'conversations_assistant.closeConfirmation.title',
    description: 'Title when user intends to close the chat window',
    defaultMessage: 'This will end your conversation.',
  },
  description: {
    id: 'conversations_assistant.closeConfirmation.description',
    description:
      'Description provided when user intends to close the chat window',
    defaultMessage: 'Are you sure you want to exit?',
  },
  confirm: {
    id: 'conversations_assistant.closeConfirmation.confirm',
    description:
      'Text shown for the close chat button when closing the chat window',
    defaultMessage: 'Yes, end chat',
  },
  cancel: {
    id: 'conversations_assistant.closeConfirmation.cancel',
    description:
      'Text shown for the cancel button when canceling closing the chat window',
    defaultMessage: 'No, keep chatting',
  },
  restartConfirm: {
    id: 'conversations_assistant.restartConfirmation.confirm',
    description: 'Confirm button for starting a new conversation',
    defaultMessage: 'Yes, start new',
  },
});

export const disclaimerMessages = defineMessages({
  disclaimer: {
    id: 'conversations_assistant.footer.disclaimer',
    description: 'Disclaimer text footer for the ai assistant',
    defaultMessage: 'AI may make mistakes. Verify important information.',
  },
  newChat: {
    id: 'conversations_assistant.footer.newChat',
    description: 'Primary action to start a new chat after a conversation ends',
    defaultMessage: 'New chat',
  },
  viewSupportCases: {
    id: 'conversations_assistant.footer.viewSupportCases',
    description: 'External link into Dashboard support cases page',
    defaultMessage: 'View support cases',
  },
});

export const headerMessages = defineMessages({
  developerDocs: {
    id: 'conversations_assistant.header.developerDocs',
    description: 'Label for the developer docs link',
    defaultMessage: 'Developer docs',
  },
  supportArticles: {
    id: 'conversations_assistant.header.supportArticles',
    description: 'Label for the support articles link',
    defaultMessage: 'Support articles',
  },
  supportCenter: {
    id: 'conversations_assistant.header.supportCenter',
    description: 'Label for the support center link',
    defaultMessage: 'Support center',
  },
  restartConversation: {
    id: 'conversations_assistant.header.restartConversation',
    description: 'Label for restart conversation link',
    defaultMessage: 'Restart conversation',
  },
  moreTooltip: {
    id: 'conversations_assistant.header.moreTooltip',
    description: 'Label for the more botton',
    defaultMessage: 'More',
  },
});

export const conversationLogMessages = defineMessages({
  chatWithAgentEnded: {
    id: 'conversations_assistant.conversationLog.chatWithAgentEndedMessage',
    description:
      'Message to show to prompt user to close chat widget to start new chat',
    defaultMessage:
      '{name} has left the chat. Ask a new question by typing below.',
  },
  chatWithAgentEndedWithHistory: {
    id: 'conversations_assistant.conversationLog.chatWithAgentEndedWithHistory',
    description:
      'Message to show after an agent leaves with conversation history enabled',
    defaultMessage:
      '{name} has left the chat. Start a new chat to ask a question, or view this case in your support center.',
  },
  conversationEnded: {
    id: 'conversations_assistant.conversationLog.conversationEnded',
    description:
      'Message to show to prompt user to close chat widget to start new chat (in the drawer)',
    defaultMessage:
      'You can now close this drawer or ask a new question by typing below.',
  },
  conversationEndedForWidget: {
    id: 'conversations_assistant.conversationLog.conversationEndedForWidget',
    description:
      'Message to show to prompt user to close chat widget to start new chat (in the widget)',
    defaultMessage:
      'The chat has ended. For further assistance, close the window and start a new chat.',
  },
  racEnded: {
    id: 'conversations_assistant.conversationLog.racEnded',
    description:
      'Message to show to prompt user to close chat widget to start new chat',
    defaultMessage:
      'Call completed. You can now close this drawer or ask Assistant a new question by typing below.',
  },
  racEndedWithHistory: {
    id: 'conversations_assistant.conversationLog.racEndedWithHistory',
    description:
      'Message to show after call completes with conversation history',
    defaultMessage:
      'Call completed. Start a new chat to ask a question, or view this case in your support center.',
  },
  racCanceled: {
    id: 'conversations_assistant.conversationLog.racCanceled',
    description:
      'Message to show to prompt user to close chat widget to start new chat due to cancellation',
    defaultMessage:
      'Call canceled. You can now close this drawer or ask Assistant a new question by typing below.',
  },
  racCanceledWithHistory: {
    id: 'conversations_assistant.conversationLog.racCanceledWithHistory',
    description:
      'Message to show after call is canceled with conversation history',
    defaultMessage:
      'Call canceled. Start a new chat to ask a question, or view this case in your support center.',
  },
  racEndedForWidget: {
    id: 'conversations_assistant.conversationLog.racEndedForWidget',
    description:
      'Message to show to prompt user to close chat widget to start new chat (in the widget)',
    defaultMessage:
      'Call received. For further assistance, close the window and start a new chat.',
  },
  racCanceledForWidget: {
    id: 'conversations_assistant.conversationLog.racCanceledForWidget',
    description:
      'Message to show to prompt user to close chat widget to start new chat due to cancellation (in the widget)',
    defaultMessage:
      'Call canceled. For further assistance, close the window and start a new chat.',
  },
});
